"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Shield = function Shield(props) {
  return _react["default"].createElement("svg", _extends({
    viewBox: "0 0 240 314",
    width: "1em",
    height: "1em"
  }, props), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M123.146 13l-70.75 101.388a8 8 0 0 0 .01 9.17l70.74 100.944L41.782 124a8 8 0 0 1-.01-10.054L123.146 13z",
    fill: "#D26C57"
  }), _react["default"].createElement("path", {
    d: "M50.957 118.976H40a7.986 7.986 0 0 1 1.772-5.031L123.146 13l-70.75 101.388a7.99 7.99 0 0 0-1.439 4.588z",
    fill: "#973A28"
  }), _react["default"].createElement("path", {
    d: "M112.776 2.38a7.607 7.607 0 0 1 11.327 10.12L43.749 113.29a8 8 0 0 0 .006 9.982l80.98 101.299a7.561 7.561 0 0 1-11.252 10.067L2.657 123.812a8 8 0 0 1 0-11.313l110.12-110.12z",
    fill: "#BD4932"
  }), _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M116.854 301l70.75-101.388a8 8 0 0 0-.01-9.17l-70.74-100.944L198.218 190a8 8 0 0 1 .01 10.054L116.854 301z",
    fill: "#D26C57"
  }), _react["default"].createElement("path", {
    d: "M189.043 195.024H200a7.986 7.986 0 0 1-1.772 5.031L116.854 301l70.75-101.388a7.99 7.99 0 0 0 1.439-4.588z",
    fill: "#973A28"
  }), _react["default"].createElement("path", {
    d: "M127.224 311.62a7.607 7.607 0 0 1-11.327-10.12l80.354-100.79a8 8 0 0 0-.006-9.982L115.265 89.43a7.561 7.561 0 0 1 11.252-10.067l110.826 110.826a8 8 0 0 1 0 11.313l-110.12 110.12z",
    fill: "#BD4932"
  }))));
};

var _default = Shield;
exports["default"] = _default;